<template>
	<el-container id="exercise_result" v-loading="test_load">
		<div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<div class="exerciseCon">
			<div class="title_box">
				{{test_tit}}
				<span>
					<i class="iconfont">&#xe6ea;</i>
					题数：{{question_total}}
				</span>
			</div>
			<div class="result_con">
				<h3 class="deliver">交卷时间：2021年8月18日  15：30</h3>
				<div class="progress_box">
					<el-progress :stroke-width='10' :show-text="false" :width="150" type="circle" :percentage="percentage" :color="colors"></el-progress>
					<div class="score">
						<h1>85.5<font>分</font></h1>
						<span>计分题200道</span>
					</div>
				</div>
				<div class="res_info">
					共200题，答对82道，答错8道<br>
					总用时1小时5分28秒
				</div>
			</div>
			<div class="btn_box">
				<div class="error_btn" @click="test_err('error')"><i class="iconfont">&#xe61a;</i>错题解析</div>
				<div class="all_btn" @click="test_err('all')"><i class="iconfont">&#xe61a;</i>全部解析</div>
				<div class="again_btn" @click="test_again"><i class="iconfont">&#xe7db;</i>再测一次</div>
			</div>
		</div>
		<!-- <div class="timeCalculationBox">
			<div class="timeBox">答题卡</div>
			<div class="timu_scroll">
				<ul>
					<li v-for="(item,key,index) in formal" :key="index" v-if="item.list.length >= 1">
						<h2>{{item.headline == "" ? big_qs_tit_txt(key) : item.headline}}</h2>
						<dl>
							<dd v-for="(obj,numindex) in testForm[key]" :class="time_cal_class(obj)" :key="numindex" @click="scrollFn(key+index+numindex)">{{numindex+1}}</dd>
						</dl>
					</li>
				</ul>
			</div>
			<ul class="tips">
				<li>正确</li>
				<li>错误</li>
			</ul>
		</div> -->
	</el-container>
</template>

<script>
export default {
	name: 'test'
	,data () {
		let formal={
			open:{		//主观题
				list:[{ //试题列表数组
					id:'233',
					title:'主观题A',  //题目名称
					choices:null,
					fill_count:1, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				},{
					id:'233',
					title:'主观题B',  //题目名称
					choices:null,
					fill_count:1, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				},{
					id:'233',
					title:'主观题B',  //题目名称
					choices:null,
					fill_count:1, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				}],
			},
			single:{	 //单选题
				list: [{ //试题列表数组
					id:'233',
					title:'单选题A',  //题目名称
					choices:[{  //选项,可能为null 例如填空题或者简答题
						flag:'A',
						content:'单选1_答案A'
					},{
						flag:'B',
						content:'单选1_答案B'
					}],
					fill_count:2, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				},{
					id:'233',
					title:'单选题B',  //题目名称
					choices:[{  //选项,可能为null 例如填空题或者简答题
						flag:'A',
						content:'单选2_答案A'
					},{
						flag:'B',
						content:'单选2_答案B'
					}],
					fill_count:2, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				}],
			},
			multiple:{		//多选题
				list:[{ //试题列表数组
					id:'233',
					title:'下列选项中，不是URL地址中所包含的信息是（     ）。',  //题目名称
					choices:[{  //选项,可能为null 例如填空题或者简答题
						flag:'A',
						content:'早餐吃啥'
					},{
						flag:'B',
						content:'午餐吃啥'
					}],
					fill_count:2, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				},{
					id:'233',
					title:'__利国家生死以，__因祸福避趋之',  //题目名称
					choices:[{  //选项,可能为null 例如填空题或者简答题
							flag:'A',
							content:'早餐吃啥'
					},{
						flag:'B',
						content:'午餐吃啥'
					}],
					fill_count:2, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				}],
			},
			judgement:{		//判断题
				list:[{ //试题列表数组
					id:'233',
					title:'判断题1',  //题目名称
					choices:[{  //选项,可能为null 例如填空题或者简答题
						flag:'A',
						content:'对'
					},{
						flag:'B',
						content:'错'
					}],
					fill_count:2, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				},{
					id:'233',
					title:'判断题2',  //题目名称
					choices:[{  //选项,可能为null 例如填空题或者简答题
							flag:'A',
							content:'是'
					},{
						flag:'B',
						content:'否'
					}],
					fill_count:2, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				}],
			},
			fill:{		//填空题
				list:[{ //试题列表数组
					id:'233',
					title:'填空题1',  //题目名称
					choices:null,
					fill_count:2, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				},{
					id:'233',
					title:'填空题2',  //题目名称
					choices:null,
					fill_count:5, //选项
					score:1, //得分
					staff_answer:'', //用户选项
				}],
			}
		}

		return {
			colors: [
				{color: '#f56c6c', percentage: 20},
				{color: '#e6a23c', percentage: 40},
				{color: '#5cb87a', percentage: 60},
				{color: '#1989fa', percentage: 80},
				{color: '#5777fe', percentage: 100}
			],
			percentage:0,
			//考试
			join_kaoshi:this.global.join_kaoshi,	//是否渲染拍摄

			// 页面参数
			test_load:true,
			location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
			},{
				title:"我的课程",
				router:"/web/courseInfo/",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{courseId:this.$route.query.courseId}
			},{
				title:"题库练习",
				router:"/web/courseInfo",
				name: 'courseInfo',
				activeIndex: 'index',
				query:{
					courseId:this.$route.query.courseId,
					menuBox:'tiku',
				}
			}],

			//试题
			test_tit:'',
			testForm:{
				single:[],
				multiple:[],
				judgement:[],
				fill:[],
				open:[],
				other1:[],
				other2:[],
			},
			formal:formal,
			question_total:0,

			//页面离开
			tijiaolikai:false,
			beforeRouteLeave_next:'',
			leave_type:'',
		}
	}
	,mounted:function(){
		var that=this
			,token=this.$cookies.get("token")
			,serverSrc=that.global.serverSrc
			,qianzui=that.global.qianzui
			,question_info
		$(".el-progress-circle__track").attr("stroke","#fff")
		//判断是否从考试安排页进入
		// if(!this.join_kaoshi.switch){
		// 	this.$alert('参数有误', '提示', {
		// 		confirmButtonText: '确定',
		// 		closeOnHashChange: false,
		// 		showClose: false,
		// 		callback: action => {
		// 			this.back_courseInfo()
		// 		}
		// 	});
		// 	return false;
		// }
		//获取试题信息
		let url = serverSrc + qianzui + "/exercises/sectionDetail"
			,get_data = {
				section_id: this.$route.query.type_id,
				type: this.$route.query.type
			}
		this.$ajax.get(url,{
			params: get_data
		})
		.then(function(res){
			let resData=res.data
			if(resData.code==0){
				question_info = resData.data

				document.title = question_info.test_title + '练习结果' + that.$store.state.titleAfter			//动态设置标题

				that.test_load = false
				that.test_tit = question_info.test_title
				that.formal = question_info.question
				that.question_total = question_info.question_total
				that.percentage = 90
				
		// 		for(var key in question_info.question){
		// 			// console.log(that.testForm);
		// 			let tiNnum=question_info.question[key].list.length,
		// 				tiArr=[]
		// 			for(let t=0;t<tiNnum;t++){
		// 				let tiId = question_info.question[key].list[t].id,
		// 					tianArr = []
		// 				if(key == "fill" || key == "other1" || key == "other2"){
		// 					for(let f=0;f<question_info.question[key].list[t].fill_count;f++){
		// 						tianArr.push("")
		// 					}
		// 				}
		// 				tiArr.push({"question_id":tiId, "answer":tianArr, "answer_img":[]})
		// 			}
		// 			that.testForm[key] = tiArr
		// 		}
				
		// 		let cal=$(".timeCalculationBox"),
		// 			calTop=cal.offset().top,
		// 			calLeft=cal.offset().left
		// 		$(window).scroll(function(){
		// 			if($(document).scrollTop() > 0){
		// 				cal.addClass("pfx").css({
		// 					top:calTop,
		// 					left:calLeft-3
		// 				})
		// 			}else{
		// 				cal.removeClass("pfx").removeAttr("style");
		// 			}
		// 		})
			}else{
				that.$alert(resData.message, '提示', {
					confirmButtonText: '确定',
					closeOnHashChange: false,
					showClose: false,
					callback: action => {
						that.tijiaolikai=true
						that.back_courseInfo()
					}
				});
			}
		})
	}
	,methods:{
		//返回到考试页
		back_courseInfo(){
			this.$router.push({
				path: this.location[2].router,
				name: this.location[2].name,
				query: this.location[2].query,
				params: ''
			})
		},
		//悬浮框高亮样式
		time_cal_class(obj){
			// return ''
			let cla=''
			if(obj.answer){
				for(var a=0;a<obj.answer.length;a++){
					if(obj.answer[a].length>0){
						cla = 'act'
						break;
					}
				}
				if(obj.answer_img.length>0){
					cla = 'act'
				}
			}
			return cla
		},
		//点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//错题解析、全部解析
		test_err(type){
			this.$router.push({
				path: '/web/courseInfo/exercise_err',
				name: 'exercise_err',
				query: {
					log_id: this.$route.query.log_id || 111,
					test_id: this.$route.query.test_id,
					courseId: this.$route.query.courseId,
					type:type
				},
				params: ''
			})
		},
		//再测一次
		test_again(){
			this.$router.push({
				path: '/web/courseInfo/exercise',
				name: 'exercise',
				query: {
					test_id: this.$route.query.test_id,
					courseId: this.$route.query.courseId
				},
				params: ''
			})
		}
	},
	computed:{
	},
}
</script>
<!-- scoped单页面有效属性 -->

<style lang="scss" scoped>
#index{background:#f4f4f4;}
</style>


// WEBPACK FOOTER //
// src/components/course_info/exercise_result.vue